import { UserProfile } from "oidc-client-ts";

export function isLoginPage(pathname: string) {
    if (pathname.startsWith("/public")) return true;
    return false;
}

export type Permission = "system" | "client" | "user";

type Context = {
    data: Record<string, any>;
    name: string;
};

export type Role = {
    contexts: Context[];
    name: string;
    permissions: Permission[];
};

export class UserData {
    public readonly userId: number;
    public readonly accountPage: string;
    private _permissions: Permission[];
    public readonly profile: UserProfile;

    constructor(userId: number, accountPage: string, profile: UserProfile, permissions: Permission[]) {
        this.userId = userId;
        this.accountPage = accountPage;
        this._permissions = permissions;
        this.profile = profile;
    }

    hasPermission(permission: Permission): boolean {
        return this._permissions.includes(permission);
    }

    get name(): string {
        return this.profile.name;
    }
}
